/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Companyzip1Inputs */

const en_entity_companyzip1 = /** @type {(inputs: Entity_Companyzip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company ZIP Code`)
};

const de_entity_companyzip1 = /** @type {(inputs: Entity_Companyzip1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmen-PLZ`)
};

/**
* | output |
* | --- |
* | "Company ZIP Code" |
*
* @param {Entity_Companyzip1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_companyzip1 = /** @type {((inputs?: Entity_Companyzip1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Companyzip1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_companyzip1(inputs)
	return de_entity_companyzip1(inputs)
});
export { entity_companyzip1 as "entity_companyZip" }